import Axios from "../config/axios-config";
import { updatePackagesStatus } from "./packages";


// Criterio de "teléfono de destinatario válido" usado para decidir qué paquetes
// salen en el PDF de etiquetas. Extraído para poder reusarlo desde los callers
// (downloadLabelsModal) al armar el lote de picking &
// packing. Acepta number o string no vacío; comportamiento idéntico al filtro
// que antes vivía inline en formatPackagesPDFDownload.
export const hasValidReceiverPhone = (pkg) => {
  const phone = pkg.receiver_phone;
  if (phone === null || phone === undefined) {
    return false;
  }
  // Convertir a string si es número
  const phoneStr = typeof phone === 'number' ? String(phone) : String(phone);
  return phoneStr.trim().length > 0;
};

export const formatPackagesPDFDownload = (packages) => {
  if (!packages || !Array.isArray(packages) || packages.length === 0) {
    console.warn('formatPackagesPDFDownload: No se recibieron paquetes válidos');
    return [];
  }

  console.log('formatPackagesPDFDownload: Paquetes recibidos:', packages.length);
  console.log('formatPackagesPDFDownload: Primer paquete de ejemplo:', packages[0] ? {
    _id: packages[0]._id,
    receiver_phone: packages[0].receiver_phone,
    receiver_phone_type: typeof packages[0].receiver_phone,
    receiver_name: packages[0].receiver_name
  } : 'No hay paquetes');

  // Filtrar paquetes que no tienen receiver_phone válido
  // Aceptar tanto strings como números, y convertir a string para validar
  const validPackages = packages.filter(pkg => {
    const isValid = hasValidReceiverPhone(pkg);
    if (!isValid) {
      const phone = pkg.receiver_phone;
      if (phone === null || phone === undefined) {
        console.warn(`Paquete ${pkg._id}: receiver_phone es null o undefined`);
      } else {
        console.warn(`Paquete ${pkg._id}: receiver_phone está vacío después de trim: "${String(phone)}"`);
      }
    }
    return isValid;
  });

  if (validPackages.length === 0) {
    console.warn('No hay paquetes válidos con receiver_phone para generar el PDF');
    return [];
  }

  if (validPackages.length < packages.length) {
    console.warn(`Se filtraron ${packages.length - validPackages.length} paquetes sin receiver_phone válido`);
  }

  return validPackages.map(pkg => {
    // Asegurar que receiver_phone sea una cadena válida
    // Convertir a string si es número
    let receiverPhone = "";
    if (pkg.receiver_phone !== null && pkg.receiver_phone !== undefined) {
      receiverPhone = typeof pkg.receiver_phone === 'number' 
        ? String(pkg.receiver_phone) 
        : String(pkg.receiver_phone).trim();
    }
    
    if (!receiverPhone || receiverPhone.length === 0) {
      console.warn(`Paquete ${pkg._id} no tiene receiver_phone válido, será omitido`);
      return null;
    }

    return {
      _id: pkg._id, // ID del paquete creado con /packages/bulk
      type: pkg.type || "Paquete", // Usar el type del paquete (OTS, WOOCOMMERCE, etc.)
      senderUser: {
        sender_id: pkg.senderUser?.id || null, // Ajusta según la estructura de senderUser en tu backend
        senderName: pkg.senderUser?.name || "",
        senderLastName: pkg.senderUser?.lastName || "",
      },
      senderInfo: {
        companyId: pkg.senderInfo?.companyId || "",
        businessName: pkg.senderInfo?.businessName || "",
        senderAddress: pkg.senderInfo?.senderAddress || "",
        senderMunicipality: pkg.senderInfo?.senderMunicipality || "",
        senderState: pkg.senderInfo?.senderState || "",
      },
      deliveryInfo: {
        logisticCompanyId: pkg.deliveryInfo?.logisticCompanyId || "",
        deliveryBusinessName: pkg.deliveryInfo?.deliveryBusinessName || "",
        operationsAddress: pkg.deliveryInfo?.operationsAddress || "",
        operationsMunicipality: pkg.deliveryInfo?.operationsMunicipality || "",
        operationsState: pkg.deliveryInfo?.operationsState || "",
      },
      receiver_name: pkg.receiver_name || "",
      receiver_lastName: pkg.receiver_lastName || "",
      receiver_phone: receiverPhone, // Asegurar que siempre tenga un valor válido
      comments: pkg.comments || "",
      status: pkg.status || 0,
      assignTo: pkg.assignTo || null,
      order_id: pkg.order_id || "",
      followingNumber: pkg.followingNumber || null,
      // Hijo de un cambio de producto: reports no lee Mongo y marca "CAMBIO ·
      // RETIRAR PRODUCTO" solo si el paquete del body lo trae. Ausente en el resto
      // (undefined no viaja en el JSON).
      exchangeOf: pkg.exchangeOf?.packageId
        ? { packageId: pkg.exchangeOf.packageId, followingNumber: pkg.exchangeOf.followingNumber }
        : undefined,
      shipping_address: {
        street_name: pkg.shipping_address?.street_name || "",
        street_number: pkg.shipping_address?.street_number || "",
        lat: pkg.shipping_address?.lat || null,
        lng: pkg.shipping_address?.lng || null,
        city: { name: pkg.shipping_address?.city?.name || "" },
        neighborhood: { name: pkg.shipping_address?.neighborhood?.name || "" },
        municipality: { name: pkg.shipping_address?.municipality?.name || "" },
        country: { name: pkg.shipping_address?.country?.name || "CHILE" },
        comment: pkg.shipping_address?.comment || "", // Usamos reference como comment si existe
        delivery_preference: pkg.shipping_address?.delivery_preference || "Normal",
        address_line: `${pkg.shipping_address?.street_name || ""}, ${pkg.shipping_address?.street_number || ""}, ${pkg.shipping_address?.municipality?.name || ""}`.replace(/^,\s*|,\s*$/g, '') || "",
      },
      map: {
        lat: [pkg.shipping_address?.lat || null],
        lng: [pkg.shipping_address?.lng || null],
      },
      failed: { images: [] }, // Asumimos que no hay imágenes de fallos por defecto
      images: [], // Asumimos que no hay imágenes asociadas por defecto
      packageStatusHistory: [], // Puedes omitir o ajustar según necesites
      inDate: pkg.inDate || new Date().toISOString(), // Usar inDate del paquete si existe
      createdAt: pkg.createdAt || new Date().toISOString(), // Usar createdAt del paquete si existe
      updatedAt: pkg.updatedAt || new Date().toISOString(), // Usar updatedAt del paquete si existe
    };
  }).filter(pkg => pkg !== null); // Filtrar cualquier null que pueda haber quedado
};

export const downloadPdf = async ({ clientId, index, packages }) => {
  try {
    // Formatear y validar paquetes antes de enviar
    const formattedPackages = formatPackagesPDFDownload(packages);
    
    if (!formattedPackages || formattedPackages.length === 0) {
      return { 
        error: { 
          message: "No hay paquetes válidos con número de teléfono para generar el PDF",
          statusCode: 400 
        } 
      };
    }

    const callUpdatePackagesStatus = updatePackagesStatus({
      ids: formattedPackages.map(pkg => pkg._id),
      newStatus: 100 // Estado "Listo para enviar"
    });

    const callReportPendingPackages = Axios.post('reports/pending-packages-pdf', {
      clientId,
      index,
      packages: formattedPackages, // Enviar los paquetes formateados y validados
    });

    const [updateResponse, responsePendingPackages] = await Promise.all([callUpdatePackagesStatus, callReportPendingPackages]);
    
    if (responsePendingPackages.error) {
      throw new Error(updateResponse.error);
    }

    return responsePendingPackages;
  } catch (err) {
    console.error("Error downloading PDF:", err.response?.data || 'Unknown error');
    // The backend body travels through when there is one; otherwise the caller's
    // fallback wins (apiBodyMessage() over `{message: null}` yields null, so no
    // transport noise like 'Unknown error' ever reaches a toast). `||`, not
    // `??`, because axios hands over `data: ''` for an empty body — an empty
    // string is falsy and would leave several callers (`if (error)`) blind.
    if (err.response) {
      return { error: err.response.data || { message: null } };
    }
    return { error: { message: null } };
  }
};
